<script>
    import { createEventDispatcher, onMount, beforeUpdate } from "svelte";
    import { writable, get } from "svelte/store";
    import { theme } from "$stores/themeStore";

    const dispatch = createEventDispatcher();
    export let showForm = false;
    export let editSite = null;
    export let studyId = null;

    let siteData = writable({
        siteId: "",
        address1: "",
        address2: "",
        city: "",
        country: "",
        email: "",
        externalId: "",
        info: "",
        email: "",
        name: "",
        owner_id: "global",
        phone: "",
        postalCode: "",
        state: "",
        status: "Inactive",
        studyId: "",
    });

    $: if (editSite) {
        const formattedSite = { ...editSite };
        siteData.set(formattedSite);
    }

    $: if (showForm && !editSite) {
        resetSiteData();
    }

    function resetSiteData() {
        siteData.set({
            siteId: "",
            address1: "",
            address2: "",
            city: "",
            country: "",
            email: "",
            externalId: "",
            info: "",
            email: "",
            name: "",
            owner_id: "global",
            phone: "",
            postalCode: "",
            state: "",
            status: "Inactive",
            studyId: studyId,
        });
    }

    function close() {
        dispatch("close");
    }

    async function handleSubmit() {
        const site = get(siteData);
        dispatch("submit", site);
        close();
    }
</script>

{#if showForm}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm"
    >
        <div class="modal-overlay absolute inset-0 bg-slate-800 opacity-75" on:click={close}></div>
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="bg-white dark:bg-gray-900 p-4 rounded-lg shadow-lg w-full max-w-3xl relative"
            on:click|stopPropagation
        >
            <header class="flex justify-between items-start mb-4">
                <h2 class="text-xl font-bold text-gray-900 dark:text-gray-100">
                    {editSite ? "Edit Site" : "New Site"}
                </h2>
                <button
                    on:click={close}
                    class="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
                >
                    &times;
                </button>
            </header>
            <form on:submit|preventDefault={handleSubmit} class="space-y-4">
                <div class="flex gap-2">
                    <div class="w-full flex justify-end">
                        <div class="w-1/4">
                            <label
                                for="status"
                                class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                                >Status</label
                            >
                            <select
                                id="status"
                                bind:value={$siteData.status}
                                class="border p-2 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                                required
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="flex gap-3 pt-10">
                    <div class="w-1/4">
                        <label
                            for="siteId"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >Site ID</label
                        >
                        <input
                            type="text"
                            id="siteId"
                            bind:value={$siteData.siteId}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                            required
                            readonly={editSite ? true : false}
                        />
                    </div>
                    <div class="w-1/2">
                        <label
                            for="externalId"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >External Id</label
                        >
                        <input
                            type="text"
                            id="externalId"
                            bind:value={$siteData.externalId}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                </div>
                <div class="flex gap-3">
                    <div class="w-full">
                        <label
                            for="name"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >Name</label
                        >
                        <input
                            type="text"
                            id="name"
                            bind:value={$siteData.name}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                            required
                        />
                    </div>
                </div>
                <div class="flex gap-3">
                    <div class="w-full">
                        <label
                            for="address1"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >Address 1</label
                        >
                        <input
                            type="text"
                            id="address1"
                            bind:value={$siteData.address1}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                </div>
                <div class="flex gap-3">
                    <div class="w-full">
                        <label
                            for="address2"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >Address 2</label
                        >
                        <input
                            type="text"
                            id="address2"
                            bind:value={$siteData.address2}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                </div>
                <div class="flex gap-3 pt-10">
                    <div class="w-1/4">
                        <label
                            for="country"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >Country</label
                        >
                        <input
                            type="text"
                            id="country"
                            bind:value={$siteData.country}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                    <div class="w-1/2">
                        <label
                            for="city"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >City</label
                        >
                        <input
                            type="text"
                            id="city"
                            bind:value={$siteData.city}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                    <div class="w-1/4">
                        <label
                            for="state"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >State</label
                        >
                        <input
                            type="text"
                            id="state"
                            bind:value={$siteData.state}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                    <div class="w-1/4">
                        <label
                            for="postalCode"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >Zipcode</label
                        >
                        <input
                            type="text"
                            id="postalCode"
                            bind:value={$siteData.postalCode}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                </div>
                <div class="flex gap-3 pt-10">
                    <div class="w-1/2">
                        <label
                            for="email"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >Email</label
                        >
                        <input
                            type="text"
                            id="email"
                            bind:value={$siteData.email}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                    <div class="w-1/2">
                        <label
                            for="phone"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200"
                            >Phone</label
                        >
                        <input
                            type="text"
                            id="phone"
                            bind:value={$siteData.phone}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                    </div>
                </div>
                <div class="flex justify-end space-x-2 pt-10">
                    <button
                        type="button"
                        on:click={close}
                        class="bg-gray-500 text-white py-1 px-2 rounded hover:bg-gray-700"
                        >Cancel</button
                    >
                    <button
                        type="submit"
                        class="bg-blue-500 text-white py-1 px-2 rounded hover:bg-blue-700"
                        >Save</button
                    >
                </div>
            </form>
        </div>
    </div>
{/if}
